import React from "react";

const BackupRestore = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>BackupRestore</h2>
        <p>Content for BackupRestore page will go here.</p>
      </div>
    </div>
  );
};

export default BackupRestore;
